// src/api/categories.js
import client from './client.js';

export const categoriesAPI = {
  getAll: (params) => client.get('/categories', { params }),
  getTree: () => client.get('/categories/tree'),
  getMenu: () => client.get('/categories/menu'), // Новый метод для меню
  getById: (id) => client.get(`/categories/${id}`),
  create: (data) => client.post('/categories', data),
  update: (id, data) => client.put(`/categories/${id}`, data),
  delete: (id) => client.delete(`/categories/${id}`),
};